import api from 'service/index';
import { getUrlParam } from 'utils/urlUtils';
import { GATES_CONTEXT, GATES_MFA } from 'constants/url';

import { Gate } from './types/Gate';
import { GateContextResponse } from './types/Context';
import { BeginMFARequest, BeginMFAResponse, LoginMFARequest, LoginMFAResponse, SendMFARequest, SendMFAResponse } from './types/Authentication';

const gatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGatesContext: build.query<GateContextResponse, void>({
      queryFn: async (_, __, ___, baseQuery) => {
        const token = getUrlParam('token') ?? getUrlParam('OSToken');

        const result = await baseQuery({
          method: 'GET',
          url: GATES_CONTEXT,
          params: token ? { token } : {},
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as GateContextResponse };
      },
    }),
    beginGateMFA: build.mutation<BeginMFAResponse, BeginMFARequest>({
      query: (params) => ({
        method: 'GET',
        url: GATES_MFA,
        params,
      }),
    }),
    sendGateMFA: build.mutation<SendMFAResponse, SendMFARequest>({
      query: (body) => ({
        method: 'POST',
        url: `${GATES_MFA}/send`,
        body,
      }),
    }),
    loginGateMFA: build.mutation<LoginMFAResponse, LoginMFARequest>({
      query: (body) => ({
        method: 'POST',
        url: `${GATES_MFA}/login`,
        body,
      }),
    }),
    getGate: build.query<Gate, string>({
      query: (id) => ({
        method: 'GET',
        url: `/gates/${id}`,
      }),
    }),
    openGate: build.mutation<void, string>({
      query: (id) => ({
        method: 'POST',
        url: `/gates/${id}/open`,
      }),
    }),
  }),
});

export const {
  useGetGatesContextQuery,
  useBeginGateMFAMutation,
  useSendGateMFAMutation,
  useLoginGateMFAMutation,
  useGetGateQuery,
  useLazyGetGateQuery,
  useOpenGateMutation,
} = gatesApi;

export default gatesApi;
